import { FC } from "react";
import {
    HR,
    InfoParameterContainer,
    InfoParameterName,
    InfoParameterValue
} from "./styled";

interface InfoParameterProps {
    name: string;
    value: string;
    link?: string;
}

export const InfoParameter: FC<InfoParameterProps> = ({ name, value, link }) => {
    return (
        <>
            <div className="flex flex-col items-center justify-center gap-2">
                <InfoParameterName>
                    {name}
                </InfoParameterName>
                <InfoParameterValue
                    onClick={() => link && window.open(link, '_self')}
                    $isLink={!!link}
                >
                    {value}
                </InfoParameterValue>
            </div>
            <HR width="50%" />
        </>
    );
}